import { render, staticRenderFns } from "./MessagesDeleted.vue?vue&type=template&id=1186c2d2&scoped=true&"
import script from "./MessagesDeleted.vue?vue&type=script&lang=js&"
export * from "./MessagesDeleted.vue?vue&type=script&lang=js&"
import style0 from "./MessagesDeleted.vue?vue&type=style&index=0&id=1186c2d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1186c2d2",
  null
  
)

export default component.exports